<h1 mat-dialog-title width="100%" style="display:flex ; flex-direction: row; justify-content: center;">Add Note</h1>
<mat-dialog-content>
  <mat-form-field style="width:100%">
    <mat-label>Note</mat-label>
    <textarea matInput rows="4" [(ngModel)]="note" cdkFocusInitial></textarea>
  </mat-form-field>
</mat-dialog-content>
<div mat-dialog-actions width="100%" style="display:flex ; flex-direction: row-reverse;">
  <button mat-button [disabled]="isEmpty" (click)="onDone()">Done</button>
  <button mat-button (click)="onCancel()">Cancel</button>
</div>
